module.exports = __webpack_public_path__ + "c4dcc119e4a27845a99b6b92773834bb.png";